// extracted by mini-css-extract-plugin
module.exports = {"pageSelector":"peoplePageToggle_pageSelector__3Qobg"};